export const userAgreementResultSelector = (state) => {
    return state.userAgreements.records.result;
};
